"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.BannerRecord = exports.BannersStateRecord = void 0;
var core_1 = __importStar(require("@gin-betting/core"));
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var _a = core_1.default.entities.constants, GET_EVENT_MATCH_OF_THE_DAY_SUCCESS = _a.GET_EVENT_MATCH_OF_THE_DAY_SUCCESS, GET_EVENT_LIVE_OF_THE_DAY_SUCCESS = _a.GET_EVENT_LIVE_OF_THE_DAY_SUCCESS;
exports.BannersStateRecord = immutable_1.Record({
    availableZones: immutable_1.Set(),
    zoneBanners: immutable_1.Map(),
    cmsBanners: [],
    fetchStatus: core_1.App.FetchStatus.INITIAL,
}, 'BannersState');
exports.BannerRecord = immutable_1.Record({ config: [], fetchStatus: core_1.App.FetchStatus.INITIAL, zoneId: null }, 'Banner');
exports.initialState = new exports.BannersStateRecord();
function makeBannerReducer(state, action) {
    if (state === void 0) { state = exports.initialState; }
    switch (action.type) {
        case constants_1.GET_BANNERS_DATA_REQUEST: {
            var _a = action.payload, zoneId = _a.variables.zoneId, args = _a.args;
            var zoneBanners = state.get('zoneBanners');
            var nextZoneBanners = void 0;
            if (zoneBanners.has(zoneId)) {
                if (args && args.isPolling)
                    return state;
                nextZoneBanners = zoneBanners.set(zoneId, zoneBanners
                    .get(zoneId)
                    .set('fetchStatus', core_1.App.FetchStatus.LOADING));
            }
            else {
                nextZoneBanners = zoneBanners.set(zoneId, new exports.BannerRecord({
                    zoneId: zoneId,
                    fetchStatus: core_1.App.FetchStatus.LOADING,
                    config: [],
                }));
            }
            return state.set('zoneBanners', nextZoneBanners);
        }
        case constants_1.GET_BANNERS_DATA_SUCCESS: {
            var _b = action.payload, data = _b.data, zoneId = _b.zoneId;
            var banners = data.banners;
            var category = state.get('zoneBanners');
            if (!zoneId) {
                return state;
            }
            var config = banners.map(function (banner) {
                var _a;
                if (banner.type === core_1.API.BannerType.betting_sport_event) {
                    var sportevent = banner.sportevent, narrowBanner = __rest(banner, ["sportevent"]);
                    return __assign(__assign({}, narrowBanner), { 
                        // TODO: "sportId" is deprecated. Remove after migration
                        sportId: (_a = narrowBanner.group) === null || _a === void 0 ? void 0 : _a.groupBy });
                }
                return banner;
            });
            var newCategory = category.set(zoneId, new exports.BannerRecord({
                zoneId: zoneId,
                config: config,
                fetchStatus: core_1.App.FetchStatus.LOADED,
            }));
            return state.set('zoneBanners', newCategory);
        }
        case constants_1.GET_BANNERS_DATA_FAIL: {
            var zoneId = action.payload.args.zoneId;
            var category = state.get('zoneBanners');
            var newCategory = category.setIn([zoneId, 'fetchStatus'], core_1.App.FetchStatus.FAILED);
            return state.set('zoneBanners', newCategory);
        }
        case constants_1.GET_CMS_BANNERS_SUCCESS: {
            var banners = action.payload.banners;
            var validBanners = banners.filter(function (cmsBanner) { return !!cmsBanner.imageSrc; });
            var cmsBanners = state.get('cmsBanners');
            var newBanners = lodash_1.unionBy(cmsBanners, validBanners, 'id');
            return state.set('cmsBanners', newBanners);
        }
        case GET_EVENT_MATCH_OF_THE_DAY_SUCCESS: {
            var _c = action.payload, matchId = _c.result, zoneId = _c.zoneId;
            var newZoneBanners = utils_1.setNewEvents({
                state: state,
                zoneId: zoneId,
                matchId: matchId,
                bannerType: core_1.API.BannerType.betting_match_of_the_day,
            });
            if (!newZoneBanners) {
                return state;
            }
            return state.set('zoneBanners', newZoneBanners);
        }
        case GET_EVENT_LIVE_OF_THE_DAY_SUCCESS: {
            var _d = action.payload, matchId = _d.result, zoneId = _d.zoneId;
            var newZoneBanners = utils_1.setNewEvents({
                state: state,
                zoneId: zoneId,
                matchId: matchId,
                bannerType: core_1.API.BannerType.betting_live_of_the_day,
            });
            if (!newZoneBanners) {
                return state;
            }
            return state.set('zoneBanners', newZoneBanners);
        }
        case constants_1.GET_BANNER_ZONES_REQUEST: {
            return state.set('fetchStatus', core_1.App.FetchStatus.LOADING);
        }
        case constants_1.GET_BANNER_ZONES_SUCCESS: {
            var bannerZones = action.payload.data.bannerZones;
            var availableZones = state.get('availableZones');
            var availableZoneIds_1 = availableZones.map(function (_a) {
                var id = _a.id;
                return id;
            });
            var newBannerZones = bannerZones.filter(function (_a) {
                var id = _a.id;
                return !availableZoneIds_1.has(id);
            });
            var nextBannerZones = availableZones.union(newBannerZones);
            return state
                .set('availableZones', nextBannerZones)
                .set('fetchStatus', core_1.App.FetchStatus.LOADED);
        }
        case constants_1.GET_BANNER_ZONES_FAIL: {
            return state.set('fetchStatus', core_1.App.FetchStatus.FAILED);
        }
        default: {
            return state;
        }
    }
}
exports.default = makeBannerReducer;
//# sourceMappingURL=reducer.js.map